/**
 * Ryan O'Dowd
 * 2024-08-06
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, safeAreaInsets}) => {
  return {
    searchbarWrapper: {
      display: 'flex',
      flexGrow: 1,
      width: '100%',
      marginBottom: safeAreaInsets.bottom,
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: 4,
      paddingRight: 4,
    },
    searchbarContainer: {
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
    },
    searchbarInner: {
      paddingBottom: 0,
      borderBottomWidth: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderColor: colors.primaryLight,
      backgroundColor: colors.primary,
    },
    searchResultsContainer: {
      flexGrow: 1,
      backgroundColor: colors.primary,
      color: colors.white,
      borderColor: colors.primaryLight,
      borderRadius: globalScale * 12,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopWidth: 0,
      marginHorizontal: 8,
      borderWidth: 4,
      marginRight: 0,
      marginBottom: 8,
      marginLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    sectionHeaderWrapper: {
      // @TODO: copied from SectionList/Header (except padding is overridden) {
      padding: globalScale * 2,
      paddingLeft: globalScale * 10,
      fontSize: globalScale * 20,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
      backgroundColor: colors.primaryDark,
      textTransform: 'capitalize',
      // @TODO: copied from SectionList/Header }

      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    chevronIcon: {
      margin: 0,
      padding: 4,
      color: colors.white,
    },
    titleAndLoading: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    isFetchingIcon: {
      marginLeft: 4,
    },
    searchResultsHeaderText: {
      fontFamily: fonts.secondaryBold,
      fontSize: globalScale * 16,
      color: colors.white,
    },
    emptySearchResultWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 8,
    },
    emptySearchResultText: {
      fontSize: globalScale * 16,
      color: colors.white,
    },
    actionsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      gap: 4,
      marginTop: 8,
    },
  };
};

export default getStyles;
